<template>
  <div class="dropdown-menu dropdown-menu_navbar shadow-sm animated--grow-in"
       :class="position"
       :style="($mq === 'mobile' || $mq === 'tablet') ? 'max-width: 100vw; right: -64px;' : 'max-width: 400px;'"
       :aria-labelledby="id_dropdown">
    <div class="dropdown-divider"></div>
    <div :style="data.pagination.total > 0 ? '' : 'justify-content: center;'"
         class="dropdown-item d-flex bg-white align-items-center py-3">
      <div>
        <span class="" v-html="data.pagination.total > 0 ? getTranslations('expression_46') : getTranslations('expression_594')"></span>
      </div>
    </div>
    <div class="dropdown-divider"></div>
    <div style="overflow-y: auto; min-width: 400px;">
      <div v-for="notification in data.pagination.data" :key="notification.id">
        <div data-toggle="modal"
             data-target="#notificationModal"
             :style="($mq === 'mobile' || $mq === 'tablet') ? 'padding-right: 40px' : ''"
             @click.prevent="showNotification(notification)"
             class="dropdown-item d-flex align-items-center py-3 cursor_pointer">
          <div class="mr-3">
            <div class="icon-circle" :class="`bg-${notification.data.color}-soft`">
              <i class="bx bx-xs" :class="`${notification.data.icon} text-${notification.data.color}`"></i>
            </div>
          </div>
          <div>
            <div class="small text-gray-500">{{ notification.created }} </div>
            <span :class="notification.status_key === 0 ? 'font-weight-bold' : ''">
              <i v-if="notification.status_key === 0" class="bx bxs-circle text-info mr-1"></i>
              <span style="overflow: hidden;
                    overflow-wrap: break-word;
                    white-space: normal;">
              {{ notification.data.title }}
                </span>
            </span>
          </div>
        </div>
        <div class="dropdown-divider"></div>
      </div>
    </div>
    <!--PAGINATION-->
    <div v-if="data.pagination.total > data.pagination.per_page">
      <div @click.stop="" class="py-3 animated--fade-in row text-center" style="justify-content: center">
        <Pagination class=""
                    page_item="background-color: #ffffff!important; border-color: #ffffff!important;"
                    page_link="background-color: #ffffff!important; border-color: #ffffff!important;"
                    :items="data.pagination"
                    :commit="pagination_commit">
        </Pagination>
      </div>
      <div class="dropdown-divider"></div>
    </div>
    <span @click.prevent="method" v-if="data.pagination.total > 0" class="cursor_pointer text-gray-500  text-center dropdown-item">
      {{ getTranslations('expression_10') }}
    </span>
  </div>
</template>

<script>
import Pagination from "../theme/Pagination";
import {mapGetters, mapState} from "vuex";

export default {
  name: "NotificationsDropdown",
  props: ['data', 'id_dropdown', 'method', 'pagination_commit', 'position'],
  components: {
    Pagination
  },
  computed: {
    ...mapState(['me', 'channels', 'configs', 'notifications', 'sources']),
    ...mapGetters([
      'getOperatorsArray',
    ])
  },
  methods: {
    showNotification(payload) {
      if(payload.status_key === 0) {
        this.$store.dispatch('updateNotification', {
          id: payload.id,
          status_key: 1
        })
        payload.status_key = 1
      }
      this.$store.commit('SET_NOTIFICATION', payload)
    },
    deleteAllNotifications() {
      this.$swal.fire({
        title: this.getTranslations('expression_310'),
        text: this.getTranslations('expression_311'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: this.getTranslations('expression_421'),
        cancelButtonText: this.getTranslations('expression_355')
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("deleteAllNotifications")
        }
      })
    },
  }
}
</script>


<style scoped>

.bg-primary-soft {
  background-color: #dae7fb !important;
}
.bg-secondary-soft {
  background-color: #d7d7d7 !important;
}
.bg-info-soft {
  background-color: #daf8fb !important;
}
.bg-warning-soft {
  background-color: #fbebda !important;
}
.bg-danger-soft {
  background-color: #fbdada !important;
}
.bg-success-soft {
  background-color: #dafbdb !important;
}

.text-primary {
  color: #0061f2 !important;
}
.logo_brand {
  height: 40px;
}
.logo {
  padding-right: 2rem;
}
.top_navbar {
  /*padding: 1.2rem 2rem;*/
  /*padding: 1rem 1.8rem;*/
  padding: .8rem 1.8rem;
}
.navigation {
  font-size: .8rem;
}
.middle {
  display: flex;
  justify-content: center;
}

.navbar-light .navbar-nav .nav-link {
  color: #aeaeae;
  /*font-weight: 300;*/
  font-family: "Product Sans Thin Regular";
  transition: color .2s;
}
.nav-link:hover {
  color: #38b5aa!important;
  /*color: #36aecc!important;*/
  transition: color .2s;
}

.navbar-light .navbar-nav .show > .nav-link, .navbar-light .navbar-nav .active > .nav-link, .navbar-light .navbar-nav .nav-link.show, .navbar-light .navbar-nav .nav-link.active {
  color: #1f1f1f!important;
  /*color: #36aecc!important;*/
  transition: color .2s;
}

</style>
